import React from "react";
import { Hyperlink } from "../../../Links/Hyperlink/Hyperlink";
import { NoHrefLink } from "../../../Links/NoHrefLink/NoHrefLink";
import { LinkListFooterLinkProps, LinkListFooterProps } from "./LinkListFooter.types";
import { LinkListFooterDefault } from "./LinkListFooterDefault/LinkListFooterDefault";
import { LinkListFooterTwoColumn } from "./LinkListFooterTwoColumn/LinkListFooterTwoColumn";

export const LinkListFooterLink: React.FC<LinkListFooterLinkProps> = (linkProps) => {
    if ("href" in linkProps) {
        return (
            <Hyperlink {...linkProps} />
        );
    } else {
        return (
            <NoHrefLink {...linkProps} />
        );
    }
};

export const LinkListFooter: React.FC<LinkListFooterProps> = (props) => {
    switch (props.type) {
        case "twocolumn":
            return (
                <LinkListFooterTwoColumn {...props} />
            );
        default:
            return (
                <LinkListFooterDefault {...props} />
            );
    }
};
